import { OrganizationRow } from 'components/tables/data/organization/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the IČO / DIČ / IČ DPH of the organization.
 */
export default function RegistrationNumbersColumn({ data: { ico, dic, icdph } }: { data: OrganizationRow }) {
  const registrationNumbers = [ico, dic, icdph].filter(Boolean).join(' / ');

  if (!registrationNumbers) {
    return null;
  }

  return (
    <P2Regular c="gray.8" lineClamp={3}>
      {registrationNumbers}
    </P2Regular>
  );
}
